import ProjectForm from "../../components/Forms/ProjectForm/ProjectForm";

export default function NewProjectPage() {
    return (
        <ProjectForm method="POST" />
    );
}